export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5462.0d5a1d04.jpg";